var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5465 8L10.6665 9.88L16.7732 16L10.6665 22.12L12.5465 24L20.5465 16L12.5465 8Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.b831eaa243fde33a24c3a4c1622031d2.svg";
export { ForwardRef as ReactComponent };